<template>
  <BaseModal name="tariffQuestionModal" width="420" :clickToClose="false" :shiftY="0.5" @before-close="() => { dataForModal = [] }"
    @before-open="openModal" :adaptive="true" height="auto" classes="bg-transparent shadow-none">
    <div
      class="modal-base-content modal-content py-20 h-100 px-30 rounded-25 bg-white position-relative overflow-hidden">
      <BaseLoader v-if="localLoading"></BaseLoader>
      <div class="d-flex justify-content-end">
        <slot name="modal-header"></slot>
        <button type="button" class="btn-close" @click="$modal.hide('tariffQuestionModal')"></button>
      </div>
      <div class="modal-content-dynamic flex-grow-1 d-flex flex-column h-100 align-items-center justify-content-center">
        <p class="fw-bold mb-15 text-center w-">
          {{ dataLang['reg_contract_modal_67'] }}
        </p>
        <div v-for="(item, index) of dataForModal" :key="index" class="fsc-12 wp-100"
          style="display: grid; grid-template-columns: 30px 1fr 1fr 55px">
          <div class="d-flex justify-content-center align-items-center border-end border-muted" style="height: 25px">
            {{ dataLang[`reg_contract_modal_${index + 68}`] }}
          </div>
          <div class="d-flex justify-content-end align-items-center border-end border-muted pe-10" style="height: 25px">
            {{ dataLang[`reg_contract_modal_${index + 77}`] }}
          </div>
          <div class="d-flex justify-content-start align-items-center border-end border-muted ps-10"
            style="height: 25px">
            {{ item[`contract_tariffs__km_t${index + 1}`] }} {{ dataLang['reg_contract_edit_22'] }}
          </div>
          <div class="d-flex justify-content-start align-items-center ps-15" style="height: 25px">
            {{ item[`contract_tariffs__t${index + 1}`] }}
          </div>
        </div>
        <div class="bg-danger text-white px-10 py-15 mt-10 fsc-12" v-html="dataLang['reg_contract_modal_66']"></div>
        <div class="d-flex justify-content-end gap-30 mt-15">
          <div @click="$modal.hide('tariffQuestionModal')"
            class="btn btn-sm py-10 btn-opposite px-30 rounded-5 d-flex align-items-center justify-content-center text-uppercase">
            Закрыть окно
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import GeneralService from '@/api/GeneralService.js'
import { VeTable } from 'vue-easytable'
import BidsService from '@/api/BidsService'
import EventBus from '@/event-bus.js'
import OwnersService from '@/api/OwnersService'

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable
  },
  data() {
    return {
      localLoading: false,
      dataForModal: [],
      tarrifs: {}
    }
  },
  methods: {
    openModal(openedParams) {
      this.localLoading = true
      this.contractId = openedParams.params.contracts__id
      Promise.all([
        GeneralService.get(`/contracts/${this.contractId}/tariffs`)
          .then((data) => {
            console.log(data);
            for (let index = 1; index <= 9; index++) {
              this.dataForModal.push({ [`contract_tariffs__km_t${index}`]: data.data.result.tariffs[`contract_tariffs__km_t${index}`], [`contract_tariffs__t${index}`]: data.data.result.tariffs[`contract_tariffs__t${index}`] })
            }
            console.log(this.dataForModal);

          })
          .catch((e) => { })
      ]).then((data) => {
        this.localLoading = false
      })
    }
  },
  mounted() { },
  created() { },
  beforeDestroy() { },

  computed: {
    ...mapState('translationModule', ['dataLang'])
  }
}
</script>
